import axios from '@/libs/api.request';


export const getBlackUserRecordsList = data => {
    return axios.request({
        url: 'api/operationLog/getBlackUserRecordsList',
        data: data,
        method: 'post'
    });
};